import { render, staticRenderFns } from "./landing-page-template.vue?vue&type=template&id=4a28b72e&scoped=true&"
import script from "./landing-page-template.vue?vue&type=script&lang=js&"
export * from "./landing-page-template.vue?vue&type=script&lang=js&"
import style0 from "./landing-page-template.vue?vue&type=style&index=0&id=4a28b72e&lang=scss&scoped=true&"
import style1 from "./landing-page-template.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28b72e",
  null
  
)

export default component.exports